<template>
	<FieldWrapper v-bind="wrapper">
		<div class="checkbox">
			<div class="checkbox__box">
				<input
					class="checkbox__inner checkbox__inner--input"
					type="checkbox"
					:id="name"
					v-model="model"
				/>
				<div class="checkbox__inner checkbox__inner--fill"></div>
			</div>
			<div class="checkbox__label">
				<label :for="name">{{ req }}<slot /></label>
			</div>
		</div>
	</FieldWrapper>
</template>

<script>
import FieldWrapper from '@/components/shared/FieldWrapper'
import field from '@/mixins/field'

export default {
	name: 'FieldCheckbox',
	computed: {
		req() {
			return !this.label && this.required ? '* ' : ''
		}
	},
	mixins: [field],
	components: {
		FieldWrapper
	}
}
</script>

<style lang="scss" scoped>
@use "sass:math";
@import '~scss/vars';
@import '~scss/components';

.checkbox {
	$width: 1rem;
	$height: $width * $line-height * 0.95;
	display: flex;
	align-items: center;
	z-index: 1;

	&__box {
		position: relative;
		width: $width;
		height: $height;
		margin-right: 1rem;
		flex-shrink: 0;
	}

	&__inner {
		position: absolute;
		top: math.div($height - $width, 2);
		left: 0;
		width: $width;
		height: $width;
		&--input {
			opacity: 0;
			z-index: 1;
		}
		&--fill {
			position: relative;
			border: 1px solid $blue-48;
		}
		&--input:checked + &--fill::after {
			content: '';
			position: absolute;
			background-color: $blue-48;
			top: 1px;
			left: 1px;
			width: calc(100% - 2px);
			height: calc(100% - 2px);
		}
	}

	&__label {
		flex-grow: 1;
	}

	input:focus + &__inner--fill::before {
		@extend %pseudo;
		$pad: 0.75rem;
		background-color: $grey-95;
		top: -$pad;
		left: -$pad;
		width: calc(100% + #{$pad * 2});
		height: calc(100% + #{$pad * 2});
		border-radius: 50%;
		z-index: -1;
	}
}
</style>
